import { Button, Paper, Popper, Stack, Typography } from '@mui/material';
import type { GcpNetworkConnectivityConfig } from '@repo/api-gw-sdk';
import { useState } from 'react';

import { GcpNetworkSelect } from '@/components/regions/gcpNetworkSelect';

export const GcpNetworkSelectionDialog = ({
  accountId,
  onClose,
  buttonRef,
  config,
}: {
  accountId: string;
  onClose: (network: string | undefined) => void;
  buttonRef: React.RefObject<HTMLButtonElement | null>;
  config: GcpNetworkConnectivityConfig[];
}) => {
  const [network, setNetwork] = useState<string | undefined>(undefined);
  const [networkHostProject, setNetworkHostProject] = useState<
    string | undefined
  >(undefined);

  return (
    <Popper
      anchorEl={buttonRef.current}
      disablePortal
      placement='bottom-start'
      open
    >
      <Paper
        className='shadow-lg'
        sx={{
          width: '308px',
          padding: '24px',
          borderRadius: '4px',
          marginTop: '-33px',
        }}
      >
        <Stack gap='24px'>
          <Typography>Choose a Network</Typography>
          <GcpNetworkSelect
            disabledItems={config.map((c) => c.network)}
            networkName={network}
            networkHostProject={networkHostProject}
            accountId={accountId}
            onChange={(networkName, networkHostProject) => {
              setNetwork(networkName);
              setNetworkHostProject(networkHostProject);
            }}
          />
          <Stack direction='row' gap='8px' justifyContent={'flex-end'}>
            <Button onClick={() => onClose(undefined)}>Cancel</Button>
            <Button
              onClick={() => onClose(network)}
              variant='contained'
              disabled={!network}
            >
              Customize Network
            </Button>
          </Stack>
        </Stack>
      </Paper>
    </Popper>
  );
};
